import { DPadHandler } from "./trackpad_dpad4";
import { DPadDayHandler } from "./trackpadday_dpad4";
import { ScrollHandler } from "./trackpad_scrolling";
import { JoystickDPadHandler } from "./joystick_dpad4";
import { JoystickDPadHandlerXr } from "./joystick_dpad4Xr";
import { AxisMoveHandler } from "./msft_mr_axis_with_deadzone";
import { AxisMoveHandler2 } from "./msft_mr_axis_with_deadzoneXr";
import { ButtonAxisActivator } from "./pressedmove";
import { ReverseYAxisEmitter } from "./ReverseYAxisEmitter";
import { actions, mappings } from "./config";

AFRAME.registerInputMappings(mappings, true);
AFRAME.registerInputActions(actions, "default");
AFRAME.registerInputBehaviour("trackpad_dpad4", DPadHandler);
AFRAME.registerInputBehaviour("trackpadday_dpad4", DPadDayHandler);
AFRAME.registerInputBehaviour("trackpad_scrolling", ScrollHandler);
AFRAME.registerInputBehaviour("joystick_dpad4", JoystickDPadHandler);
AFRAME.registerInputBehaviour("joystick_dpad4Xr", JoystickDPadHandlerXr);
AFRAME.registerInputBehaviour("msft_mr_axis_with_deadzone", AxisMoveHandler);
AFRAME.registerInputBehaviour("msft_mr_axis_with_deadzoneXr", AxisMoveHandler2);
AFRAME.registerInputActivator("pressedmove", ButtonAxisActivator);
AFRAME.registerInputActivator("reverseY", ReverseYAxisEmitter);
